<template>
    <b-form>
        <!-- disable input fields when the user can only view and not update  -->
        <b-form-group
            id="comments-group"
            label="Comments"
            label-for="input-comments"
            label-cols="3"
            label-class="font-weight-bold pt-0"
        >
            <b-form-textarea
                type="text"
                id="input-comments"
                v-model="model.comments"
                required
                placeholder="Enter comments"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            id="completed-group"
            label="Completed"
            label-for="input-completed"
            label-cols="3"
            label-class="font-weight-bold pt-0"
        >
            <b-form-checkbox
                type="text"
                id="input-completed"
                v-model="model.completed"
                :value="1"
                :unchecked-value="0"
            ></b-form-checkbox>
        </b-form-group>
    </b-form>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-viewCheckoffForm',
    mixins: [permissionsMixins],
    data: () => ({
        model: {},
    }),
    props: ['value', 'status'],
    watch: {
        model: {
            handler: function (val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },
    mounted() {
        this.model = { ...this.value }
    },
}
</script>